import { createApi } from '@reduxjs/toolkit/query/react';
import { createApiConfig } from '../../../createApiConfig';

export const lMChangeGetLinkApi = createApi({
  reducerPath: 'lMChangeGetLinkApi',
  ...createApiConfig(process.env.REACT_APP_API_BASE_URL),
  tagTypes: ['ChangeLink'],
  endpoints: (builder) => ({
    

    getLinks: builder.mutation({
      query: (body) => ({
        url: '/links/get-link-details/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ChangeLink'],
    }),
    changeCampaign: builder.mutation({
      query: (body) => ({
        url: '/links/change-campaign/',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ChangeLink'],
    }),
    changeStatus: builder.mutation({
      query: (body) => ({
        url: `/links/change-status/`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ChangeLink'],
    }),

    
  }),
});

export const {
  useGetLinksMutation,
  useChangeCampaignMutation,
  useChangeStatusMutation,
} = lMChangeGetLinkApi;
